import { getUserSettingsModalSearch } from 'ComponentLibrary'
import { STATIC_APP_PATHS } from 'ClientPortal/src/router/constants'
import { Navigate, useLocation, useSearchParams } from 'react-router-dom'

const UserSettingsPage = () => {
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const nextSearchParams = new URLSearchParams(location.search)
    nextSearchParams.delete('new_user')
    const pathname = searchParams.has('new_user') ? STATIC_APP_PATHS.orderListPage : STATIC_APP_PATHS.dashboard

    return <Navigate to={{ pathname, search: getUserSettingsModalSearch(nextSearchParams, 'profile') }} replace />
}

export default UserSettingsPage
